import React, { useState, useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';
import './Slider.css'; 


import image1 from '../../../assets/slider/front.jpg';
import image2 from '../../../assets/slider/2nd.png';
import image3 from '../../../assets/slider/3rd.jpg';

const Slider = ({ onGalleryPress, onBookNowPress ,onContactPress }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);

    const slides = [
        {
            image: image1,
            title: "Luxury Banquet & Marquee",
            description: "Experience the perfect venue for your special occasions",
            buttonText: "Book Now",
            showButton: true,
             buttonAction: () => onBookNowPress && onBookNowPress()
        },
        {
            image: image2,
            title: "Grand Events & Celebrations",
            description: "Create unforgettable memories with our premium services",
            buttonText: "View Gallery",
            showButton: true,
             buttonAction: () => onGalleryPress && onGalleryPress()
        },
        {
            image: image3,
            title: "Professional Event Management",
            description: "Complete event planning and execution services",
            buttonText: "Contact Us",
            showButton: true,
             buttonAction: () => onContactPress && onContactPress()
        }
    ];


    useEffect(() => {
        let interval;
        if (isAutoPlaying) {
            interval = setInterval(() => {
                nextSlide();
            }, 3000); 
        }
        
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [currentSlide, isAutoPlaying]);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

   

    const goToSlide = (index) => {
        setCurrentSlide(index);
        setIsAutoPlaying(false);
        setTimeout(() => setIsAutoPlaying(true), 3000);
    };



    return (
        <div className="slider-container">
          
            <div className="slider-wrapper">
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`slide ${index === currentSlide ? 'active' : ''}`}
                        style={{ backgroundImage: `url(${slide.image})` }}
                    >
                       
                        <div className="slide-overlay"></div>
                        
                     
                        <Container>
                            <div className="slide-content">
                                <h1 className="slide-title">{slide.title}</h1>
                                <p className="slide-description">{slide.description}</p>
                                
                                {slide.showButton && (
                                    <Button 
                                        variant="warning" 
                                        size="lg"
                                        className="slide-button"
                                        onClick={slide.buttonAction}
                                    >
                                        {slide.buttonText}
                                    </Button>
                                )}
                            </div>
                        </Container>
                    </div>
                ))}

              
               

             
                <div className="slide-indicators">
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            className={`indicator ${index === currentSlide ? 'active' : ''}`}
                            onClick={() => goToSlide(index)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Slider;